var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcSearchV2 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.828 15.785a7.985 7.985 0 1 1 15.97 0 7.985 7.985 0 0 1-15.97 0M14.813 6.2a9.585 9.585 0 1 0 0 19.17c2.223 0 4.27-.758 5.897-2.029l3.724 3.725a.8.8 0 1 0 1.132-1.132l-3.681-3.68a9.55 9.55 0 0 0 2.512-6.47A9.585 9.585 0 0 0 14.813 6.2",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSearchV2);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };